<template>
  <div class="questionBank_info_list_set_type_11">
    <!-- 新增||编辑试题 - 作业环境判断 -->
    <el-form ref="questionData" :model="questionData" label-width="120px" size="mini" :rules="questionDataRules">
      <el-form-item label="题目内容" prop="questionName" class="form-item" style="width: 100%;">
        <el-input size="small" show-word-limit maxlength="200" type="textarea" resize="none" rows="3" clearable
          placeholder="请输入题目内容" v-model="questionData.questionName">
        </el-input>
      </el-form-item>
      <el-form-item label="考试内容" prop="examContent">
        <el-input show-word-limit maxlength="1000" type="textarea" resize="none" rows="4"
          v-model="questionData.examContent" clearable></el-input>
      </el-form-item>
      <el-form-item label="扣分标准" prop="evaluationStandard">
        <el-input show-word-limit maxlength="500" type="textarea" resize="none" rows="3"
          v-model="questionData.evaluationStandard" clearable></el-input>
      </el-form-item>
      <el-form-item label="配分" prop="score" class="form-item">
        <el-input-number v-model="questionData.score" :precision="1" :step="1" :min="0" :max="100"
          placeholder="请输入配分"></el-input-number>
      </el-form-item>
      <el-form-item label="双人考核" prop="twoPersonSubmit" class="form-item">
        <el-switch v-model="questionData.twoPersonSubmit"></el-switch>
      </el-form-item>
      <el-form-item prop="tableData" class="form-item">
        <el-table ref="multipleTable" :data="tableData" :header-cell-style="tableHeader" size="small"
          tooltip-effect="dark" stripe style="width: 100%;">
          <el-table-column property="content" label="勾选否决项" width="80px" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.veto"
                @change="(value) => checkTableData(value, scope.$index)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column property="content" label="选项内容" min-width="260" align="center">
            <template slot-scope="{ row }">
              <span style="font-size: 14px;display: inline-block;width: 20px;">{{ row.key }}.</span>
              <el-input v-model="row.content" placeholder="请输入选项内容"
                style="display: inline-block;width: calc(100% - 20px);"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="safeWork" label="可否作业" width="100" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.safeWork" placeholder="T 或 F"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="pageNumber" label="页号" width="80" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.pageNumber" placeholder="页号"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="temperature" label="温度" width="80" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.temperature" placeholder="温度(℃)"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="weather" label="天气" width="90" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.weather" placeholder="请输入天气情况"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="windDirection" label="风向" width="100" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.windDirection" placeholder="请输入风向"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="windSpeed" label="风速(*级)" width="90" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.windSpeed" placeholder="请输入1~10级"></el-input>
            </template>
          </el-table-column>
          <el-table-column property="score" label="扣除分值(分)" min-width="100" align="center">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.score" :precision="1" :step="1" :min="0" :max="100"
                placeholder="请输入"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="delRow(scope.$index)">删除选项</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="success" icon="el-icon-plus" size="mini" @click="addRow" style="margin-top: 10px;"
          :disabled="tableData.length > 20">添加选项</el-button>
      </el-form-item>
      <el-form-item class="btnBox">
        <el-button class="bgc-bv" @click="doClose">取消</el-button>
        <el-button class="bgc-bv" @click="getSure">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import List from "@/mixins/List";
export default {
  name: "examinationAffairsManage_questionBank_info_list_set_type_11",
  components: {

  },
  props: {
    // 基本信息
    basicInfo: {
      bankId: "", // 题库id
      itemId: "", // 考核科目id
      subjectId: "", // 科目id
      itemCode: "", // 科目标识
      itemName: "", // 科目名称
      contentId: "", // 考核内容id
      questionId: "", // 考题id(编辑用)
      questionType: "", // 题目类型
    },
  },
  mixins: [List],
  data() {
    return {
      // 题目基础 - 数据
      questionData: {
        questionName: '',// 题目内容
        score: "", // 配分
        examContent: "", // 考核内容
        evaluationStandard: "", // 扣分标准
        twoPersonSubmit: false,    // 是否双人作答
      },
      // 题目基础 - 数据 - 校验
      questionDataRules: {
        questionType: [
          { required: true, message: '请选择题目类型', trigger: 'change' }
        ],
        questionName: [
          { required: true, message: "请输入题目内容", trigger: "blur" },
        ],
        examContent: [
          { required: true, message: "请输入考核内容", trigger: "blur" },
        ],
        evaluationStandard: [
          { required: true, message: "请输入扣分标准", trigger: "blur" },
        ],
        score: [
          { required: true, message: "请输入配分", trigger: "blur" },
        ],
      },
      // 选项列表数据
      tableData: [{
        key: 'A', // 选项
        content: '', // 内容
        img: '', // 图片地址
        safeWork: '',      // 正确/错误
        pageNumber: '',    // 页号
        temperature: '',   // 温度
        weather: '',       // 天气
        windDirection: '', // 风向 （从左到右或从右到左）
        windSpeed: '',     // 风速
        score:"",          // 分值
        veto: false,       // 否定项
      }],
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    if (this.basicInfo.questionId) {
      this.getSubjectInfo();
    }
  },
  methods: {
    // 获取 - 试题详情
    getSubjectInfo() {
      this.$post("/biz/bank/pa-question-bank/getQuestion", {
        questionId: this.basicInfo.questionId
      }, 3000, true, 10)
        .then((res) => {
          this.questionData = { ...this.questionData, ...res.data };
          console.log(this.questionData)
          delete this.questionData.optionJson;
          this.tableData = JSON.parse(res.data.optionJson);
        })
        .catch((err) => {
          return;
        });
    },

    // 选项列表 - 删除选项
    delRow(index) {
      this.tableData.splice(index, 1)
      this.tableData.forEach((e, i) => {
        e.key = this.optionFM(i)
      })
    },
    // 选项列表 - 添加选项
    addRow(row) {
      this.tableData.push({
        key: this.optionFM(this.tableData.length),
        content: '', // 内容
        img: '', // 图片地址
        safeWork: '',      // 正确/错误
        pageNumber: '',    // 页号
        temperature: '',   // 温度
        weather: '',       // 天气
        windDirection: '', // 风向 （从左到右或从右到左）
        windSpeed: '',     // 风速
        score:"",          // 分值
        veto: false,       // 否定项
      })
    },
    // 选项列表 - 勾选 - 处理选项列表数据
    checkTableData(check, index) {},
    // 选项列表 - 图片上传
    handleAvatarSuccess2(res, file, row) {
      let extension = res.name.substring(
        res.name.lastIndexOf(".") + 1,
        res.name.length
      );
      let formData = new FormData();
      formData.append("file", res.raw);
      formData.append("fileType", extension);
      formData.append("folder", "PRACTICAL_QUESTION_BANK");
      formData.append("isPublic", false);
      const that = this;
      that
        .$Postformat("/sys/file/upload/url", formData, 3000, true, 10)
        .then((result) => {
          that.tableData.forEach((e, i) => {
            if (e.index == row.index) {
              row.img = result.data.fileUrl || "";
            }
          })
        })
        .catch((err) => {
          setTimeout(() => {
            that.$message({
              type: "warning",
              message: "上传失败",
            });
          }, 300);
        });
    },
    // 取消
    doClose() {
      this.$router.back();
    },
    // 保存
    getSure() {
      this.$refs['questionData'].validate((valid) => {
        if (valid) {
          let cData = {
            contentId: this.basicInfo.contentId, // 考核内容id
            questionId: this.basicInfo.questionId, // 考核内容id(有则编辑,无则添加)
            questionType: this.basicInfo.questionType, // 题目类型
            ...this.questionData,
            optionJson: JSON.stringify(this.tableData)
          }
          this.$post("/biz/bank/pa-question-bank/itemQuestionSaveUpdate", cData, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功');
              this.$refs['questionData'].resetFields();
              this.questionData = this.$options.data().questionData;
              this.tableData = [{
                key: 'A', // 选项
                content: '', // 内容
                img: '', // 图片地址
                temperature: '', // 温度
                weather: '', // 天气
                windSpeed: '', // 风速
                safeWork: '', // 正确/错误
                score:"", // 分值
                veto: false, // 正确答案
              }];
              // 编辑试题 - 编辑完自动返回上一页
              if (this.basicInfo.questionId) {
                this.doClose();
              }
            })
            .catch((err) => {
              return;
            });
        }
      })
    },
    // 选项顺序替换成字母
    optionFM(msg) {
      return String.fromCharCode('A'.charCodeAt(0) + msg);
    },
    // 选项字母替换成顺序
    optionFN(msg) {
      return msg.charCodeAt(0) - 'A'.charCodeAt(0);
    },
  },
};
</script>
<style lang="less" scoped>
.img-el-upload {
  margin: 0 auto;
  width: 88px;
  height: 88px;
}

/deep/.el-upload {
  width: 100%;
  height: 100%;
}

.up_video {
  width: 80px;

  /deep/ .el-upload {
    border: 0 !important;
  }
}
</style>
